var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoints(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.643,
    height: 21.446,
    viewBox: "0 0 23.643 21.446",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18415",
    "data-name": "Group 18415",
    transform: "translate(0.292 0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18299",
    "data-name": "Group 18299",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25338",
    "data-name": "Path 25338",
    d: "M53.788,124H45.306v2.655h9.735V124Z",
    transform: "translate(-38.623 -105.709)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17835",
    "data-name": "Group 17835"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18301",
    "data-name": "Group 18301"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25339",
    "data-name": "Path 25339",
    d: "M22.765,2.3a1.68,1.68,0,0,0-1.905-.862,1.752,1.752,0,0,0-.841.477c.067-.391.089-.621.089-.621a.623.623,0,0,0,.627-.7h.006S20.684,0,20.156,0H2.9c-.528,0-.586.593-.586.593H2.32a.623.623,0,0,0,.627.7s.023.23.09.621A1.752,1.752,0,0,0,2.2,1.434a1.679,1.679,0,0,0-1.9.862A3.751,3.751,0,0,0,.439,5.512c1.2,2.617,4.11,3.548,5.738,3.87.026.005.672.155.7.155l.017,0a7.882,7.882,0,0,0,3.037,1.65v4.137a3.583,3.583,0,0,1-2.037,2.968h7.275a3.571,3.571,0,0,1-1.992-2.968V11.186a7.976,7.976,0,0,0,3.014-1.65c.005,0,0,0,.006,0,.025,0,.666-.15.692-.155,1.628-.322,4.536-1.253,5.735-3.87A3.75,3.75,0,0,0,22.765,2.3M1.144,5.189A3.072,3.072,0,0,1,.966,2.678a.906.906,0,0,1,1.047-.491.886.886,0,0,1,.7.782,1.058,1.058,0,0,1-.8,1.046.388.388,0,0,0,.2.749,1.905,1.905,0,0,0,1.289-1.2A13.4,13.4,0,0,0,5.9,8.529c-1.519-.362-3.8-1.242-4.759-3.34m20.767,0c-.961,2.1-3.239,2.977-4.759,3.34a13.4,13.4,0,0,0,2.492-4.967,1.905,1.905,0,0,0,1.289,1.2.388.388,0,0,0,.2-.749,1.058,1.058,0,0,1-.8-1.046.886.886,0,0,1,.7-.782.906.906,0,0,1,1.047.491,3.072,3.072,0,0,1-.178,2.511",
    transform: "translate(0)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 0.5
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoints);
export default __webpack_public_path__ + "static/media/points.18eb32aea78be6f0f0a1af1dc564a723.svg";
export { ForwardRef as ReactComponent };